import React, { useEffect, useState } from 'react'
import { DataTable, Heading5, Icon } from '../widgets';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Button, Card, Col, Modal, Row } from 'react-bootstrap';
import { SubNav } from '../layout/submenu';
import { deleteRateScheduls, getRateScheduleLists, saveRateSchedules } from '../../actions/rate-schedule';
import RateScheduleModal from '../all-settings/RateScheduleModal';
import { getUserId } from '../../helpers/session';
import { searchWord, usePermission } from '../../helpers/common';
import LoadIcon from '../../../assets/images/rate-load.svg';
import MileIcon from '../../../assets/images/rate-miles.svg';
import TonIcon from '../../../assets/images/rate-ton.svg';
import moment from "moment-timezone";
import { dateUTCToTimezone, toDisplayDateTimeString } from '../../helpers/moment-ex';

const RateSchedules = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const allow = usePermission();
  const isAllowEdit = allow('rate-schedules', 'edit');
  const isAllowCreate = allow('rate-schedules', 'create');
  const isAllowDelete = allow('rate-schedules', 'delete');

  const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
  const rateScheduleList = useSelector((state) => state.rateSchedule.rateScheduleList);
  const isRateRequesting = useSelector((state) => state.rateSchedule.isRateRequesting)
  const [searchText, setSearchText] = useState("");
  const [rateShow, setRateShow] = useState(false);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [isEditRateModal, setEditRateModal] = useState(false);
  const [isRateSaved, setIsRateSaved] = useState(false)
  const [rateList, setRateList] = useState([]);
  const [editedData, setEditedData] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);
  const selectedRateName = deleteItem && deleteItem.rate_name ? deleteItem.rate_name : null;
  const timezone = useSelector(state => state.farm.currentFarm.timezone_identifier);
  const getTimeZoneDate = date => {
    const tzDate = dateUTCToTimezone(date, timezone);
    const currentTzDate = dateUTCToTimezone(moment.utc(), timezone);
    const isCurrentYear = (tzDate.year() === currentTzDate.year());

    return toDisplayDateTimeString(tzDate, isCurrentYear);
  };


  useEffect(() => {
    if (farmId) dispatch(getRateScheduleLists(farmId))
  }, [farmId])

  const getStatus = (statusId) => {
    if (statusId === 1)
      return <span className="badge badge-pill badge-success badge-sm" style={{ fontWeight: 400 }}>active</span>;
    else
      return <span className="badge badge-pill badge-danger badge-sm" style={{ fontWeight: 400 }}>locked</span>;
  };

  const handleConfirmModal = (it) => {
    setDeleteModal(true);
    setDeleteItem(it)
  }
  const enableEditRateModal = (it) => {
    setEditRateModal(true);
    setRateShow(true);
    setEditedData(it);
  }
  const handleClose = () => {
    setRateShow(false);
    setEditRateModal(false);
  };
  const handleSave = () => {
    if ((rateScheduleList && rateScheduleList.length > 0) && (rateList && rateList.length > 0)) {
      let changedItems = rateList.map((rate) => {
        return {
          ...rate,
          rate_schedule_applicable: rate.rate_schedule_applicable ? 1 : 0,
        }
      }).filter(current => {
        const previous = rateScheduleList.find(prev => prev.rate_uuid === current.rate_uuid);
        return previous && previous.rate_schedule_applicable !== current.rate_schedule_applicable;
      });

      changedItems = changedItems.map(changedItem => {
        return {
          rate_uuid: changedItem.rate_uuid,
          rate_name: changedItem.rate_name,
          rate_type_uuid: changedItem.rate_type_uuid,
          rate_value: changedItem.rate_value,
          rate_schedule_applicable: changedItem.rate_schedule_applicable,
          surcharge_applicable: changedItem.surcharge_applicable,
          surcharge_type_uuid: changedItem.surcharge_type_uuid,
          surcharge_value: changedItem.surcharge_value
        }
      })

      const rateParams = {
        farm_uuid: farmId,
        user_id: getUserId(),
        rate_schedule: changedItems
      }
      dispatch(saveRateSchedules(rateParams))
    }

    setIsRateSaved(false);
  };

  const confirmDeleteRate = () => {
    const cb = (isSaved) => {
      if (isSaved) setRateList((prevList) => prevList.filter((item) => item.rate_uuid !== deleteItem.rate_uuid));
    };

    let deletedId = deleteItem && deleteItem.rate_uuid ? deleteItem.rate_uuid : '';
    deletedId = {
      rate_uuid: deletedId
    }

    const params = {
      farm_uuid: farmId,
      user_id: getUserId(),
      rate_schedule: [deletedId]
    }
    dispatch(deleteRateScheduls(params, cb));
  }

  useEffect(() => {
    if (isRateSaved) {
      handleSave()
      setIsRateSaved(false);
    }
  }, [isRateSaved])

  const getRateIcons = (name) => {
    switch (name ? name.toLowerCase() : null) {
      case 'load':
        return LoadIcon;
      case 'mile':
        return MileIcon;
      case 'ton':
        return TonIcon;
      default:
        return null;
    }
  };

  if (isRateRequesting) return <div>Loading ....</div>;
  return (
    <div className='content-inner h-100 rate-schedule-container'>
      <Card className='h-100'>
        <Card.Header>
          <Card.Title className='mb-0'>
            <Row>
              <Col>
                <Heading5>Rate Schedules</Heading5>
              </Col>
              <Col className='col-4'>
                <Button
                  className='btn btn-sm float-right'
                  variant='danger'
                  onClick={() => {
                    const url = `/home/farm/${farmId}/map`;
                    history.push(url);
                  }}>
                  <i className='fa fa-times-circle mr-1' />
                  Cancel
                </Button>

                {isAllowCreate && <span className={'split'}>
                  <SubNav.Divider className={'splitter float-right'} />
                </span>}

                {isAllowCreate && <Button
                  variant="success"
                  size="sm"
                  className="float-right"
                  onClick={() => {
                    setRateShow(!rateShow)
                  }}
                >
                  <Icon className="fa fa-plus"></Icon> Add Rate Schedules
                </Button>}
              </Col>
            </Row>

          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Col lg={4} md={4} sm={4} className="px-0 mt-1 mb-4">
            <SubNav.SearchBox
              placeholder="Search for Rate Schedule Name"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              onClear={() => setSearchText("")}
            />
          </Col>
          <DataTable>
            <DataTable.Header>
              <DataTable.Row>
                <DataTable.Cell style={{ width: "100px" }}>#</DataTable.Cell>
                <DataTable.Cell>Rate Schedule Name</DataTable.Cell>
                <DataTable.Cell style={{ width: "200px" }}>Based On</DataTable.Cell>
                <DataTable.Cell style={{ width: "200px" }}>Created Date</DataTable.Cell>
                <DataTable.Cell style={{ width: "200px" }}>Modified Date</DataTable.Cell>
                <DataTable.Cell style={{ width: "100px" }}>Status</DataTable.Cell>
                {(isAllowEdit || isAllowDelete) && <DataTable.Cell className="center" style={{ width: "100px" }}>Action</DataTable.Cell>}
              </DataTable.Row>
            </DataTable.Header>

            <DataTable.Body>
              {rateScheduleList && rateScheduleList.length > 0 ? (
                rateScheduleList.filter((rate) => rate && searchWord(rate.rate_name, searchText)).sort((a, b) => new Date(b.created_date) - new Date(a.created_date)).map((e, i) => (
                  <DataTable.Row key={`${e.rate_uuid}-${i}`}>
                    <DataTable.Cell style={{ width: "100px" }}>{i + 1}</DataTable.Cell>
                    <DataTable.Cell>{e.rate_name}</DataTable.Cell>
                    <DataTable.Cell style={{ width: "200px" }}>{e.rate_type_name ? (<img src={getRateIcons(e.rate_type_name)} alt={e.rate_type_name ? e.rate_type_name : ''} />) : null} {(e.rate_type_name !== 'Mile' && e.surcharge_applicable === 1 && (e.range_miles && e.range_miles.length > 0)) ? <img src={getRateIcons('mile')} alt='Range Mile' /> : null}</DataTable.Cell>
                    <DataTable.Cell style={{ width: "200px" }}>{e.created_date ? getTimeZoneDate(e.created_date) : "-"}</DataTable.Cell>
                    <DataTable.Cell style={{ width: "200px" }}>{e.modified_date ? getTimeZoneDate(e.modified_date) : "-"}</DataTable.Cell>
                    <DataTable.Cell>
                      {getStatus(e.rate_schedule_applicable)}
                    </DataTable.Cell>
                    {(isAllowEdit || isAllowDelete) && <DataTable.Cell className="center" style={{ width: "90px" }}>
                      <div className="m-0 px-1 d-flex jusitfy-content-center rate-actions">
                        {isAllowEdit && <div className="btn-icon p-0">
                          <Icon className="fa fa-pencil" title="Edit" id={e.rate_uuid}
                            onClick={() => { enableEditRateModal(e) }}></Icon>
                        </div>}

                        {isAllowEdit && isAllowDelete && <span className={'split'}>
                          <SubNav.Divider className={'splitter h-100'} />
                        </span>}
                        {isAllowDelete && <div className="btn-icon p-0">
                          <Icon className="fa fa-trash" title="Delete" id={e.rate_uuid}
                            onClick={() => { handleConfirmModal(e) }}></Icon>
                        </div>}
                      </div>
                    </DataTable.Cell>}
                  </DataTable.Row>
                ))
              ) : (
                <DataTable.Row>
                  <DataTable.Cell colSpan={7} style={{ textAlign: "center" }}>
                    No data available
                  </DataTable.Cell>
                </DataTable.Row>
              )}
            </DataTable.Body>
          </DataTable>

        </Card.Body>
      </Card>

      {rateShow || isEditRateModal ? <RateScheduleModal
        show={rateShow}
        handleClose={handleClose}
        farmId={farmId}
        rateList={rateList}
        setRateList={setRateList}
        handleSave={handleSave}
        isEditRateModal={isEditRateModal}
        setEditRateModal={setEditRateModal}
        editedData={editedData}
        setIsRateSaved={setIsRateSaved} /> : null}

      {showDeleteModal ?
        <Modal.Confirm
          isOpen={showDeleteModal}
          onConfirm={confirmDeleteRate}
          iconClassName='fa fa-trash'
          className="modal_delete_hover"
          body={<div className='col'>Do you want to delete  <b className='text-danger'>{selectedRateName}</b> including its selection on the crews?</div>}
          confirmButton={{
            content: "Delete",
            className: "btn-danger",
          }}
          cancelButton={{
            content: "Cancel",
            className: "btn-cancel",
            autoFocus: true,
          }}
          onHide={() => setDeleteModal(false)}
        /> : null}
    </div>
  )
}

export default RateSchedules;